// extracted by mini-css-extract-plugin
module.exports = {"block":"e_Js","lead":"e_Ks","faces":"e_Ls","face":"e_Ms","plus":"e_Ns","copy":"e_Os","title":"e_Ps","text":"e_Qs","button":"e_Rs","buttonIcon":"e_Ss"};